interface AthleteCoachData {
  id?: number;
  athleteId?: number;
  coachId?: number;
  teamId?: number;
  teamAccess?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
}


export class AthleteCoach {
  public static readonly ACCESS_FROM_ATHLETE: number = 0;
  public static readonly ACCESS_FROM_TEAM: number = 1;

  public static getNonTranslatableFields(): string[] { return ['id', 'athleteId', 'coachId', 'teamId', 'teamAccess', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'athleteId', 'coachId', 'teamId', 'teamAccess', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  athleteId?: number;
  coachId?: number;
  teamId?: number;
  teamAccess?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  public static fromAPI(data: AthleteCoachData): AthleteCoach {
    return new AthleteCoach(data);
  }

  public static fromAPIList(data: AthleteCoachData[]): AthleteCoach[] {
    return data.map((item: AthleteCoachData) => AthleteCoach.fromAPI(item));
  }

  constructor({id, athleteId, coachId, teamId, teamAccess, createDate, createrId, updateDate, updaterId, deleteDate, deleterId} : AthleteCoachData) {
    this.id = id;
    this.athleteId = athleteId;
    this.coachId = coachId;
    this.teamId = teamId;
    this.teamAccess = teamAccess;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): Object {
    return {
      id: this.id,
      athleteId: this.athleteId,
      coachId: this.coachId,
      teamId: this.teamId,
      teamAccess: this.teamAccess,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }

}
